export const decimals = 1000000000000000000;
export const USDC_ADDR = '0xE923CD10386C0e196fb9EcA75F2A3994d46794b1';
export const WMATIC_ADDR = '0xaa2ABC23B36E906cE603C6d19A88F0873A701b87';
export const USDC_VAULT = '0x3F84668d2AF41D150546f5cd5bd3f8f1DE88669E';
export const WMATIC_VAULT ='0x1371bB5c0F7cceAA80aDb528778930A11f17e365';
export const LOAN_DETAILS='0xAa757d5FCf39fd49E94010BE19eA3462D368F33d';